import React from 'react';
import { View, Text } from 'react-native';
import {stringIsEmpty} from "../../constants/StringChecker";
import {formatDate} from "../../constants/formatDate";
import RatingDisplay from "../../components/rating/RatingDisplay";
import {Spacing} from "../../components";
import Colors from "../../constants/Colors";

const ReviewRender = (props) => {

    const reviewerId = props.reviewerId;
    const createdAt = props.createdAt;
    const comment = props.reviewComment;
    const points = props.reviewPoints;

    const isLast = props.isLast;
    const borderBottomWidth = isLast === true ? 0.4 : 0.0

    return(
        <View style={{ borderWidth: 0.4, borderBottomWidth: borderBottomWidth, padding: 18, borderColor: 'gray' }}>

            <RatingDisplay points={points} />
            <Spacing height={20} />

            {
                stringIsEmpty(comment) === false &&
                    <Text style={{ fontSize: 16, color: Colors.fontColorOnBackground }}>
                        { comment }
                    </Text>
            }
            <Spacing height={6} />
            <Text style={{ fontSize: 14, color: Colors.fontColorOnBackground }}>
                {/*{ `Revisado por ${reviewerId} em ${formatDate(createdAt)}` }*/}
                { `Revisado em ${formatDate(createdAt)}` }
            </Text>

        </View>
    )
}

export default ReviewRender;
